import { client } from '@/common-utils/libraries/axios/axios';
import PAYLUDD_BENEFICIARIES from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationDeleteBeneficiary = (onSuccess, onError) => {
    return {
        mutationFn: ({ contractAccessId, beneficiaryUuid }) => {
            return client.delete(
                replaceParameters(PAYLUDD_BENEFICIARIES.DELETE_PAYLUDD_BENEFICIARY.url, {
                    contractAccessId,
                    beneficiaryUuid
                })
            );
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationDeleteBeneficiary;

